// extracted by mini-css-extract-plugin
export default {"main":"events_main__kQtMi","homeimage":"events_homeimage__DxFX2","upper":"events_upper__M6Sjn"};